import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import EmptyStateIllustration from 'Pods/ThreeDStudio/Shared/EmptyStateIllustration/EmptyStateIllustration'

import { NOOP } from 'Utils/stableDefaults'

// Controlled like the rest of the panel: the host decides whether any filter is
// active and what "Clear Filters" does, so this stays free of any pod-specific
// store. See CommunityGalleryPanel for the prop contract.
function EmptyState({ hasActiveFilters = false, onClearFilters = NOOP }) {
  return (
    <div className="community-gallery-empty-state" role="status">
      <div className="community-gallery-empty-state__content">
        <EmptyStateIllustration />
        <div className="community-gallery-empty-state__text">
          <p className="community-gallery-empty-state__title cgt-heading-300">
            No models found matching your criteria
          </p>
          <p className="community-gallery-empty-state__description cgt-body-md">
            Try adjusting your search or selecting different filters
          </p>
        </div>
      </div>
      {hasActiveFilters && (
        <div className="community-gallery-empty-state__actions">
          <Button type="secondary" size="small" onClick={onClearFilters}>
            Clear Filters
          </Button>
        </div>
      )}
    </div>
  )
}

EmptyState.propTypes = {
  hasActiveFilters: bool,
  onClearFilters: func,
}

export default EmptyState
